webpackJsonp([152729541867738],{

/***/ 1378:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusPlacementCheckInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"action","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"CensusPlacementAction","ofType":null}}},{"defaultValue":null,"description":null,"name":"appointmentId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"destinationKennelId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"patientId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":"A proposed placement to check. `RESERVE_APPOINTMENT` requires `appointmentId`\nand derives the patient from it; `PLACE_PATIENT` requires `patientId`. The\nfield for the other action is ignored.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-census-placement-check-input-06e4b46b73eb178d3994.js